import { useEffect, useState } from "react";
import { api, inr } from "../../lib/api";

export default function MerchantAnalytics() {
    const [data, setData] = useState({ daily: [], top_products: [], totals: {} });
    const [days, setDays] = useState(7);

    useEffect(() => {
        api.get(`/merchant/analytics?days=${days}`).then(({ data }) => setData(data));
    }, [days]);

    const maxRev = Math.max(1, ...data.daily.map((d) => d.revenue));

    return (
        <div>
            <div className="flex items-center justify-between flex-wrap gap-3">
                <div><h1 className="text-2xl font-bold">Analytics</h1><p className="text-sm text-muted-foreground mt-1">Sales trends across your restaurants</p></div>
                <div className="flex items-center gap-2">
                    {[7, 14, 30, 90].map((d) => (
                        <button key={d} data-testid={`days-${d}`} onClick={() => setDays(d)} className={`text-xs font-semibold px-3 py-1.5 rounded-full border ${days === d ? "bg-foreground text-background border-foreground" : "border-border"}`}>{d}d</button>
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-3 gap-3 mt-6">
                <Card label="Orders" v={data.totals?.orders ?? 0} />
                <Card label="Revenue" v={inr(data.totals?.revenue || 0)} />
                <Card label="AOV" v={inr(data.totals?.avg_order_value || 0)} />
            </div>

            <h3 className="font-bold mt-8 mb-3">Daily revenue</h3>
            <div className="bg-card border border-border rounded-2xl p-5">
                {data.daily.length === 0 ? (
                    <p className="text-center text-sm text-muted-foreground py-8">No delivered orders in this range yet.</p>
                ) : (
                    <div className="flex items-end gap-2 h-48" data-testid="daily-chart">
                        {data.daily.map((d) => (
                            <div key={d.date} className="flex-1 flex flex-col items-center gap-1">
                                <div className="text-[10px] font-semibold text-muted-foreground">{inr(d.revenue)}</div>
                                <div className="w-full bg-primary rounded-t-lg transition-all" style={{ height: `${Math.max(4, (d.revenue / maxRev) * 100)}%`, minHeight: "4px" }} title={`${d.orders} orders`} />
                                <div className="text-[10px] text-muted-foreground">{d.date.slice(5)}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <h3 className="font-bold mt-8 mb-3">Top items</h3>
            <div className="bg-card border border-border rounded-2xl overflow-hidden">
                <table className="w-full text-sm">
                    <thead><tr className="bg-muted/60 text-left text-[11px] uppercase tracking-wider"><th className="px-4 py-3">Item</th><th className="px-4 py-3">Qty sold</th><th className="px-4 py-3">Revenue</th></tr></thead>
                    <tbody>
                        {data.top_products.map((p) => (
                            <tr key={p.product_id} data-testid={`top-${p.product_id}`} className="border-t border-border">
                                <td className="px-4 py-3 font-semibold">{p.name}</td>
                                <td className="px-4 py-3">{p.qty}</td>
                                <td className="px-4 py-3">{inr(p.revenue)}</td>
                            </tr>
                        ))}
                        {data.top_products.length === 0 && <tr><td colSpan={3} className="text-center py-8 text-muted-foreground">No items sold yet</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function Card({ label, v }) {
    return (
        <div className="bg-card border border-border rounded-2xl p-4">
            <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground font-bold">{label}</p>
            <p className="text-2xl font-bold mt-1">{v}</p>
        </div>
    );
}
